import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from './useApiClient';

interface ShareInstallationRequest {
    installationId: string;
    targetTenantId: string;
}

interface ShareInstallationResponse {
    success: boolean;
    message: string;
    sharedInstallation: {
        installationId: string;
        targetTenantId: string;
        name: string;
        sharedAt: string;
    };
}

export const useGitHubInstallationShare = () => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();

    return useMutation<ShareInstallationResponse, Error, ShareInstallationRequest>({
        mutationFn: async ({ installationId, targetTenantId }) => {
            const response = await apiClient.post('/github/installations/share', {
                installationId,
                targetTenantId
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to share installation');
            }

            return response.json();
        },
        onSuccess: () => {
            // Invalidate GitHub configurations to refresh the list
            queryClient.invalidateQueries({ queryKey: ['githubSshConfigs'] });
            queryClient.invalidateQueries({ queryKey: ['githubConfigurations'] });
        },
    });
};